import type { FC } from 'react';
import { color } from './colorsLib';

// Данная функция выбирает контрастрый цвет
const invertColor = (hex: string) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    // https://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#ffffff';
};

const checkActiveColor = (currentColor?: string, color?: string): boolean =>
    currentColor?.toLowerCase() === color?.toLowerCase();

interface ColorProps {
    currentColor?: string;
    color: string;
    setCurrentColor: (arg: string) => void;
}
const Color: FC<ColorProps> = ({ currentColor, color, setCurrentColor }) => {
    const invertedColor = invertColor(color);
    const isActive = checkActiveColor(currentColor, color);

    const border = isActive ? `4px solid ${invertedColor}` : 'none';

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        setCurrentColor(color);
    };

    return (
        <div
            style={{
                background: color,
                width: '28px',
                height: '28px',
                border,
            }}
            className="cursor-pointer"
            onClick={handleClick}
        />
    );
};

interface PickerColorsProps {
    currentColor?: string;
    needOuterIndent?: boolean;
    setCurrentColor: (value: string) => void;
}
export const PickerColors: FC<PickerColorsProps> = ({
    currentColor = '#ffffff',
    needOuterIndent = true,
    setCurrentColor,
}) => {
    return (
        <div className={`flex flex-col bg-white ${needOuterIndent ? 'my-6' : ''}`}>
            {color.map((parent, rowIndex) => (
                <div key={rowIndex} className="flex">
                    {parent.map((item, colIndex) => (
                        <Color
                            key={`${rowIndex}-${colIndex}`}
                            currentColor={currentColor}
                            color={item}
                            setCurrentColor={setCurrentColor}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};
